import type { AgentSettingsApi } from '@env0/agent-settings-service/api';

export const DEFAULT_AGENT_ID: AgentSettingsApi.DefaultAgentId = 'ENV0_DEFAULT';
